export const getAdminShopUrl = () => {
  if (location.origin === 'https://admin.ginzaxiaoma.net') {
    return `https://admin-shop.ginzaxiaoma.com`;
  }

  return `https://test-store2.ginzaxiaoma.com`;
};

const ADMIN_SHOP_URL = getAdminShopUrl();

export default ADMIN_SHOP_URL;



// WEBPACK FOOTER //
// ./src/utils/admin-shop-url.js